import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            精彩看点
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            精选深度内容，带你用不同视角看娱乐世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors duration-300 group cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`吃瓜在线 - ${item.title}`}
                  title={`${item.title} - 吃瓜在线精彩看点`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/60 rounded-md px-2 py-1 text-white text-xs whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {mediaItems.slice(3).map((item, i) => (
            <div
              key={i + 3}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors duration-300 group cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="relative w-full sm:w-48 aspect-video sm:aspect-auto overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={item.image}
                  alt={`吃瓜在线 - ${item.title}`}
                  title={`${item.title} - 吃瓜在线精彩看点`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/10 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-lg text-primary-500 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 flex flex-col justify-center">
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="whitespace-nowrap">{item.duration}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}